export enum SubscriptionCreateOinAtEnum {
  BEFORE_BILLING_DATE = 'working_day_before_billing_date',
  AFTER_BILLING_DATE = 'working_day_after_billing_date',
}
